import styled, { css } from 'styled-components';
import { flexColumn, flexCenterVertical } from '@stylesheets/helpers';

export const GroupContainer = styled.div`
  ${({ theme: { colors } }) => css`
    border-bottom: 1px solid ${colors.surfaceContainerHighest};

    &:last-child {
      border-bottom: none;
    }
  `}
`;

export const GroupHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;

  ${({ theme: { spacing, colors } }) => css`
    gap: ${spacing.level2};
    padding: ${spacing.level3} ${spacing.level4};

    &:hover {
      background: ${colors.surfaceContainerLow};
    }
  `}
`;

export const HeaderLeft = styled.div`
  ${flexColumn};
  min-width: 0;
  flex: 1;

  gap: 2px;
`;

export const DateRange = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    font-weight: ${font.labelLarge.fontWeight};
    color: ${colors.onSurface};
  `}
`;

export const UserName = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.labelSmall.fontSize};
    line-height: ${font.labelSmall.lineHeight};
    color: ${colors.outline};
  `}
`;

export const HeaderRight = styled.div`
  ${flexCenterVertical};
  flex-shrink: 0;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level3};
  `}
`;

export const CreditsBadge = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    font-weight: ${font.labelLarge.fontWeight};
    color: ${colors.onSurface};
  `}
`;

export const SourceBadge = styled.span`
  ${({ theme: { font, colors, spacing, borderRadius } }) => css`
    font-size: ${font.labelSmall.fontSize};
    font-weight: ${font.labelSmall.fontWeight};
    letter-spacing: 0.04em;
    padding: 2px ${spacing.level2};
    border-radius: ${borderRadius.small};
    background: ${colors.surfaceContainerHighest};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const ExpandIcon = styled.span<{ $expanded: boolean }>`
  display: inline-flex;
  transition: transform 0.2s ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '180deg' : '0deg')});

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurfaceVariant};
    font-size: 18px;
  `}
`;

export const DetailContainer = styled.div`
  ${({ theme: { colors, spacing } }) => css`
    background: ${colors.surfaceContainerLow};
    padding: ${spacing.level2} ${spacing.level4} ${spacing.level3};
  `}
`;

export const DetailLoading = styled.div`
  ${({ theme: { font, colors, spacing } }) => css`
    padding: ${spacing.level3} 0;
    font-size: ${font.bodySmall.fontSize};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const MessageCount = styled.span`
  ${({ theme: { font, colors } }) => css`
    font-size: ${font.labelSmall.fontSize};
    line-height: ${font.labelSmall.lineHeight};
    color: ${colors.onSurfaceVariant};
  `}
`;

export const LegacyTable = styled.div`
  ${flexColumn};

  ${({ theme: { colors, spacing, borderRadius } }) => css`
    background: ${colors.surfaceContainer};
    border-radius: ${borderRadius.medium};
    padding: ${spacing.level2};
    margin-top: ${spacing.level2};
    gap: 1px;
  `}
`;

export const LegacyRow = styled.div`
  ${flexCenterVertical};
  justify-content: space-between;

  ${({ theme: { font, colors, spacing, borderRadius } }) => css`
    font-size: ${font.labelSmall.fontSize};
    line-height: ${font.labelSmall.lineHeight};
    color: ${colors.onSurfaceVariant};
    padding: ${spacing.level1} ${spacing.level2};
    border-radius: ${borderRadius.small};

    &:nth-child(odd) {
      background: ${colors.surfaceContainerLow};
    }
  `}
`;

export const LegacyDate = styled.span`
  ${({ theme: { colors } }) => css`
    color: ${colors.outline};
  `}
`;

export const LegacyAmount = styled.span`
  ${({ theme: { font } }) => css`
    font-weight: ${font.labelLarge.fontWeight};
    font-variant-numeric: tabular-nums;
  `}
`;

export const RetryLink = styled.button`
  all: unset;
  cursor: pointer;
  text-decoration: underline;

  ${({ theme: { colors } }) => css`
    color: ${colors.primary};

    &:focus-visible {
      outline: 2px solid ${colors.primary};
      outline-offset: 2px;
    }
  `}
`;
